// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7_83e","delete":"styles_delete__2mgZ2","update":"styles_update__3SZWa","add":"styles_add__2NeGj"};